const HTML_ESCAPE_MAP = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
};

export const escapeHtml = (value) => {
  if (value == null) {
    return "";
  }

  return String(value).replace(/[&<>"']/g, (char) => HTML_ESCAPE_MAP[char]);
};

const UNSAFE_SCHEME_PATTERN = /^\s*javascript:/i;
const SAFE_URL_PATTERN = /^(https?:\/\/|\/|#)/i;

export const sanitizeUrl = (url) => {
  if (url == null || url === "") {
    return "#";
  }

  const normalized = String(url).trim();

  if (
    UNSAFE_SCHEME_PATTERN.test(normalized) ||
    !SAFE_URL_PATTERN.test(normalized)
  ) {
    return "#";
  }

  return normalized;
};

export const escapeAttrUrl = (url) => escapeHtml(sanitizeUrl(url));
